import React, { useState } from 'react'
import GridContainer from '@naturacosmeticos/natds-web/dist/Components/GridContainer'
import Container from '@material-ui/core/Container'
import GridItem from '@naturacosmeticos/natds-web/dist/Components/GridItem'
import withStyles from '@material-ui/core/styles/withStyles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import scrollTo from 'gatsby-plugin-smoothscroll'
import clsx from 'clsx'
import Tabs from '@material-ui/core/Tabs'
import { FormattedMessage, injectIntl } from 'react-intl'
import NavItem from '../NavItem'
import HomeLink from '../HomeLink'
import useDataLayer from '../../hooks/useDataLayer'

const styles = () => ({
  root: {
    height: '40px'
  },
  menuList: {
    display: 'flex',
    margin: 0
  }
})

const PureHorizontalMenu = ({
  width,
  classes,
  className,
  homeUrl,
  logoImage,
  menuItems = [],
  intl,
  isEloThemeActive
}) => {
  const url = typeof window !== 'undefined' ? window.location.href : '#'
  const activeTabUrl = menuItems.findIndex(item => {
    const regex = new RegExp(`${item.href}$`)
    return url.match(regex)
  })

  const initialActiveTab = activeTabUrl === -1 ? 0 : activeTabUrl
  const [activeTab, setActiveTab] = useState(initialActiveTab)
  const dataLayer = useDataLayer()

  const pushDataLayer = item => {
    dataLayer.push({
      event: 'navigationClick',
      sectionId: intl.formatMessage({ id: item.gtmLabel }),
      buttonText: intl.formatMessage({ id: item.label })
    })
  }

  return (
    isWidthUp('md', width) && (
      <GridContainer
        alignItems="center"
        container
        component={Container}
        direction="row"
        itemScope
        justify="space-between"
      >
        <GridItem>
          <HomeLink 
            href={homeUrl} 
            isExternal={false} 
            data-gtm-category-ga4="landing_header"
            data-gtm-label-ga4="logo"
            data-gtm-main-action-ga4="click"
          >
            {logoImage}
          </HomeLink>
        </GridItem>
        <GridItem className={classes.root}>
          <Tabs
            component="nav"
            indicatorColor="secondary"
            className={clsx(classes.menuList, className)}
            onChange={(e, index) => {
              setActiveTab(index)
            }}
            value={activeTab}
            TabIndicatorProps={{
              style: {
                backgroundColor: isEloThemeActive ? "#F6BE0F" : null
              },
            }}
          >
            {Array.isArray(menuItems) &&
              menuItems.map((item, index) => (
                <NavItem
                  id={`${item.id}-horizontal-menu-item`}
                  active={activeTab}
                  data-testid="menu-item"
                  index={index}
                  key={item.label}
                  label={<FormattedMessage id={item.label} />}
                  onClick={() => {
                    pushDataLayer(item)
                    scrollTo(item.href)
                    setActiveTab(index)
                  }}
                  data-gtm-category-ga4="landing_header"
                  data-gtm-label-ga4={intl.formatMessage({ id: item.label })}
                  data-gtm-main-action-ga4="click"
                />
              ))}
          </Tabs>
        </GridItem>
      </GridContainer>
    )
  )
}

const HorizontalMenuWithIntl = injectIntl(PureHorizontalMenu)
const HorizontalMenuWithStyles = withStyles(styles)(HorizontalMenuWithIntl)
const HorizontalMenu = withWidth({ initialWidth: 'sm' })(
  HorizontalMenuWithStyles
)

export default HorizontalMenu
